import {
  COUNTRY_LIST_REQUEST,
  COUNTRY_LIST_SUCCESS,
  COUNTRY_LIST_FAILURE,
  SET_MESSAGE_REQUEST,
  RESEND_OTP_FAILURE,
  RESEND_OTP_SUCCESS,
  VALIDATE_COMPANY_REQUEST,
  VALIDATE_COMPANY_SUCCESS,
  VALIDATE_COMPANY_FAILURE,
  SET_PASSWORD_FAILURE,
  SET_VALIDATE_COMPANY
} from './constants';

let initialState = {
  currentlySending: false,
  countryList: [],
  message: '',
  messageType: '',
  companyValidation: {}
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case COUNTRY_LIST_REQUEST:
      return { ...state, currentlySending: true };
    case COUNTRY_LIST_SUCCESS:
      return { ...state, countryList: action.countryList, currentlySending: false };
    case COUNTRY_LIST_FAILURE:
      return { ...state, countryList: [], currentlySending: false };
    case SET_MESSAGE_REQUEST:
      return { ...state, message: action.message, messageType: action.messageType || '' };
    case RESEND_OTP_SUCCESS:
      return { ...state, message: action.message, messageType: 'success' };
    case RESEND_OTP_FAILURE:
      return { ...state, message: action.error, messageType: 'error' };
    case VALIDATE_COMPANY_REQUEST:
      return { ...state };
    case VALIDATE_COMPANY_SUCCESS:
      return { ...state, companyValidation: action.companyValidation };
    case VALIDATE_COMPANY_FAILURE:
      return { ...state, companyValidation: {} };
    case SET_VALIDATE_COMPANY:
      return { ...state, currentlySending: false, companyValidation: action.payload };
    case SET_PASSWORD_FAILURE:
      return { ...state, message: action.error, messageType: 'error' };
    default:
      return state;
  }
}

export default reducer;
